import { useCallback, useEffect, useState } from 'react';

/** Seconds a fresh link must wait before it can be sent again. */
export const RESEND_COOLDOWN_S = 30;

/** "0:30", "1:05". */
export function formatCountdown(seconds: number): string {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/**
 * Seconds left of a countdown that starts on mount; `restart` starts it over
 * (a link was just sent again).
 */
export function useCountdown(seconds: number) {
  const [endsAt, setEndsAt] = useState(() => Date.now() + seconds * 1000);
  const [left, setLeft] = useState(seconds);

  useEffect(() => {
    const tick = () =>
      setLeft(Math.max(0, Math.ceil((endsAt - Date.now()) / 1000)));
    tick();
    const interval = setInterval(tick, 250);
    return () => clearInterval(interval);
  }, [endsAt]);

  const restart = useCallback(() => {
    setEndsAt(Date.now() + seconds * 1000);
    setLeft(seconds);
  }, [seconds]);

  return { left, restart };
}
